// src/pages/BCPForm.tsx - Refactored to use BCPFormContainer
import React from 'react';
import BCPFormContainer from '../components/BCP/BCPFormContainer';

const BCPForm: React.FC = () => {
  return <BCPFormContainer />;
};

export default BCPForm;